import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class CategorySelectController extends Controller {
  static targets = [
    "categorySelect"
  ];

  categorySelectTargetConnected(el) {
    this.categorySelect = new SlimSelect({
      select: el,
      placeholder: "Escolha...",
      searchText: "Nenhum resultado...",
      searchPlaceholder: "Pesquise...",
      searchingText: "Pesquisando...",
      allowDeselect: false,
      addToBody: true,
      ajax: (search, callback) => {
        if (!search) return false;

        if (this.categorySelectTimeout) clearTimeout(this.categorySelectTimeout);

        this.categorySelectTimeout = setTimeout(() => {
          this.searchCategories(search, callback);
        }, 300);
      },
    });
  }

  categorySelectTargetTargetDisconnected(el) {
    this.categorySelect.destroy();
  }

  searchCategories(search, callback) {
    const self = this;
    var url_string = "/admin/categories/slim_select_search";
    const url = new URL(url_string, document.baseURI);
    url.searchParams.append("search", search);

    fetch(url)
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (typeof callback !== "undefined") {
            callback(data);
          } else {
            self.categorySelect.setData(data);
            self.categorySelect.setSelected(null);
          }
        })
        .catch(function (error) {
          if (callback) callback(false);
        });
  }
}
